import React from 'react';
import { FormControlProps } from '@mui/material/FormControl/FormControl';
import { OutlinedInputProps } from '@mui/material/OutlinedInput/OutlinedInput';
import { useField } from 'formik';
import { CustomChangeEvent, CustomFocusEvent } from '../../../@types/helper';
import TextInput from './TextInput';

interface IFormTextInputProps {
    label : string;
    name : string;
    formControlProps ?: FormControlProps;
    inputProps ?: OutlinedInputProps;
    onChange ?: (e : CustomChangeEvent) => void;
    onBlur ?: (e : CustomFocusEvent) => void;
    className ?: string;
    type ?: string;
    disabled ?: boolean;
    selectOnFocus ?: boolean;
    startAdornment ?: React.ReactNode;
    multiline ?: boolean;
    rows ?: number;
    transparentBackground ?: boolean;
    children ?: React.ReactNode;
}

const FormTextInput = (props : IFormTextInputProps) : React.ReactElement => {
    const [field, meta, helper] = useField(props.name);

    const onChange = (e : CustomChangeEvent) : void => {
        helper.setValue(e.currentTarget.value);
        if (props.onChange) props.onChange(e);
    };

    const onBlur = (e : CustomFocusEvent) : void => {
        field.onBlur(e);
        if (props.onBlur) props.onBlur(e);
    };

    return (
        <TextInput
            {...props}
            value={field.value}
            onChange={onChange}
            onBlur={onBlur}
            hasError={!!meta.error}
            error={meta.error}
        />
    );
};

export default FormTextInput;
